<div *ngIf="content"
     class="flex-column flex-justify-center flex-middle pos-relative _container"
     [ngSwitch]="storageData.step">

    <!-- back button -->
    <div class="pos-absolute z-2 top-0 p-t-5 left-0 p-l-10 p-l-4-s p-l-4-m w-12 bg-col-w">
        <button *ngIf="storageData.step !== ESteps.configure"
                class="col-12 inline-flex flex-middle"
                (click)="back()">
            <i class="icon-arrow-simple-left icon-medium inline-flex"></i>
            <span class="p1 m-l-2">{{'Back' |translate}}</span>
        </button>
    </div>


    <div *ngSwitchDefault
         class="w-10 w-12-s w-9-m p-a p-r-5-s p-l-5-s p-b-3-s p-t-3-s overflow-auto custom-scrollbar"
         style="overflow: auto">
        <!-- title -->
        <h1 class="h2 center"
            *iCms="'firstStepTitle' of content"></h1>

        <!-- carousel -->
        <div class="m-t-10 m-t-6-s _configuration-step">
            <div *ngFor="let element of content.firstStepOptions; let index = index"
                 [class._active]="storageData.configOption === getConfigOption(index)"
                 class="_element cursor-pointer"
                 (click)="selectFirstStep(index)">
                <div class="ratio-1-1 ratio-3-2-s ratio-3-2-m"
                     [style.margin.px]="2">
                    <img class="rf _image"
                         [image]="client.sizeId < 2 && element.mobileImage ? element.mobileImage : element.image">
                </div>
                <p class="m-t m-b-3 p1 center"
                   *iCms="'name' of element"></p>
            </div>
        </div>
    </div>

    <ng-container *ngSwitchCase="ESteps.rider">
        <simple-step [content]="riderStepData"
                     [(selection)]="storageData.rider!"
                     (selectionChange)="updateStorage()"></simple-step>
    </ng-container>

    <ng-container *ngSwitchCase="ESteps.horse">
        <simple-step [content]="horseStepData"
                     [(selection)]="storageData.horse!"
                     (selectionChange)="updateStorage()"
                     [squareVariant]="true"></simple-step>
    </ng-container>


    <!-- button -->
    <button *ifSize="'XL'"
            class="m-t-8 m-b button"
            [disabled]="!isDataValid()"
            [ga4TrackClick]="getGA4Data()"
            (click)="next()">{{'Confirm & Continue' | translate}}</button>
</div>
<div *ifSize="'SM'"
     class="pos-fixed _bottomConfirm z-2 bg-col-w w-12 p-a box-shadow-1">
    <button class="w-12 button"
            [disabled]="!isDataValid()"
            [ga4TrackClick]="getGA4Data()"
            (click)="next()">{{'Confirm & Continue' | translate}}</button>
</div>